<template>
    <div class="default_list">
         <div class="nav app_title_list">
            <mt-tab-item @click.native="prevent('tab-container3')"> <span :class="active == 'tab-container3'?'title_switch_if':'title_switch'">时政快讯</span> </mt-tab-item>
            <!-- <mt-tab-item @click.native="prevent('tab-container4')"><span :class="active == 'tab-container4'?'title_switch_if':'title_switch'">手机报</span></mt-tab-item> -->
        </div>
            
        <div class="page-tab-container">
            <mt-tab-container class="page-tabbar-tab-container" v-model="active" swipeable>
                <mt-tab-container-item id="tab-container3">
                    <!-- cell组件 -->
                    <AppContentList></AppContentList>
                </mt-tab-container-item>
                <mt-tab-container-item id="tab-container4">
                    <!-- cell组件 -->
                    <AppContentLista></AppContentLista>
                </mt-tab-container-item>
            </mt-tab-container>
        </div>
    </div>
</template>
<script>
import AppContentList from '@/components/appModule/homePageAppTwo/appContentList/index'
// 手机报
import AppContentLista from '@/components/appModule/homePageAppThree/appContentLista/index'


export default {
  name: 'page-tab-container',
  data() {
    return {
      active: 'tab-container3'
    };
  },
  components:{
      AppContentList,
      AppContentLista
  },
  methods:{
    prevent(val){
      this.active = val
    }
  }
};
</script>
<style lang="">
    .default_list{
        padding-top:1rem;
    }
  .item {
    display: inline-block;
  }
 
  
  .link {
    color: inherit;
    padding: 20px;
    display: block;
  }
  .app_title_list{
      display:flex;
      justify-content: space-around;
  }
  .app_title_list .mint-tab-item{
    padding:0;
    text-align: center;
    font-size: 1.4rem !important;
  }

  .app_title_list .mint-tab-item .mint-tab-item-label{
    font-size: 1.2rem !important;
    font-family: Source Han Sans CN;
  }
  .title_switch{
    height:2.2rem;
    line-height: 2.2rem;
    display: block;
    border-bottom:0.01rem solid #fff;
  }
  .title_switch_if{
    height:2.2rem;
    line-height: 2.2rem;
    display: block;
    color: #C90304;
    font-weight: bolder;
    border-bottom:0.1rem solid #C90304;
  }
</style>


// WEBPACK FOOTER //
// src/components/appModule/homePageAppTwo/index.vue